import { ManagementListToolbar, RecordFormDialog } from "@taunggyi-plus/design-system";
import { useFeedback } from "@taunggyi-plus/auth";
import { useCallback, useEffect, useState } from "react";
import { useAuth } from "@taunggyi-plus/auth";
import { Card, PaginatedList } from "@taunggyi-plus/design-system";
export function AdminTeam() {
  const { client } = useAuth();
  const [rows, setRows] = useState<{ email: string; capability: string }[]>([]),
    [message, setMessage] = useFeedback(),
    [busy, setBusy] = useState(false);
  const [query, setQuery] = useState("");
  const filteredRows = rows.filter((row) =>
    `${row.email} ${row.capability}`.toLowerCase().includes(query.toLowerCase()),
  );
  const load = useCallback(async () => {
    if (!client) return;
    const r = await client.rpc("admin_staff_list");
    if (r.error) throw new Error(r.error.message);
    setRows((r.data ?? []) as { email: string; capability: string }[]);
  }, [client]);
  useEffect(() => {
    const timer = setTimeout(() => void load().catch((e) => setMessage(e.message)), 0);
    return () => clearTimeout(timer);
  }, [load, setMessage]);
  return (
    <Card>
      <ManagementListToolbar
        query={query}
        onQueryChange={setQuery}
        searchLabel="Search staff"
        resultCount={filteredRows.length}
        onClear={() => setQuery("")}
        actions={
          <RecordFormDialog title="Manage staff permission">
            <form
              className="form-grid"
              onSubmit={async (e) => {
                e.preventDefault();
                if (!client || busy) return;
                const f = new FormData(e.currentTarget);
                setBusy(true);
                try {
                  const r = await client.rpc("set_admin_staff", {
                    email: f.get("email"),
                    capability: f.get("capability"),
                    enabled: f.get("action") === "grant",
                  });
                  if (r.error) throw new Error(r.error.message);
                  await load();
                  setMessage("Permission updated.");
                } catch (e) {
                  setMessage(e instanceof Error ? e.message : "Could not save.");
                } finally {
                  setBusy(false);
                }
              }}
            >
              <label className="field">
                Existing account email
                <input name="email" type="email" required />
              </label>
              <label className="field">
                Permission
                <select name="capability">
                  {["finance", "support", "management"].map((s) => (
                    <option key={s}>{s}</option>
                  ))}
                </select>
              </label>
              <label className="field">
                Action
                <select name="action">
                  <option value="grant">Grant</option>
                  <option value="remove">Remove</option>
                </select>
              </label>
              <button className="button" disabled={busy}>
                Update permission
              </button>
            </form>
          </RecordFormDialog>
        }
      />
      {message && <p role="status">{message}</p>}
      <PaginatedList
        items={filteredRows}
        resetKey={query}
        label="Admin staff pages"
        renderItem={(r) => (
          <p key={`${r.email}:${r.capability}`}>
            {r.email} · {r.capability}
          </p>
        )}
      />
    </Card>
  );
}
export function StaffWorkspace({ capabilities }: { capabilities: string[] }) {
  return (
    <Card>
      {capabilities.includes("finance") && (
        <>
          <p>
            <a href="/finance">Finance and payment receipts</a>
          </p>
          <p>
            <a href="/more/subscription-requests">Subscription payment approvals</a>
          </p>
        </>
      )}
      {capabilities.includes("support") && (
        <p>
          <a href="/more/service-help">Service cases</a>
        </p>
      )}
      {capabilities.includes("management") && (
        <>
          <p>
            <a href="/more/events">Events and participation</a>
          </p>
          <p>
            <a href="/more/promotions">Advertising approvals</a>
          </p>
          <p>
            <a href="/more/ad-packages">Advertising packages</a>
          </p>
        </>
      )}
    </Card>
  );
}
